import React from 'react';
import CollapsibleSection from './CollapsibleSection';
import type { PanelChrome } from './layout';

interface PanelFrameProps {
	chrome?: PanelChrome;
	icon: React.ReactNode;
	title: string;
	count: number;
	/**
	 * Header action, given a way to expand the section. Nothing is folded when
	 * bare, so there the callback does nothing.
	 */
	action?: (expand: () => void) => React.ReactNode;
	/**
	 * Where the action sits when bare. `below` parks it under the list and
	 * stretches it, which is what the table layout wants: each row already ends
	 * in its own buttons, and one more floating above the header row competes
	 * with them. Ignored when the collapsible header is drawn, since that holds
	 * the action itself.
	 */
	actionPlacement?: 'above' | 'below';
	children: React.ReactNode;
}

const noop = () => {};

/** Shared shell for the issues, reviews and feedback panels. */
const PanelFrame: React.FC<PanelFrameProps> = ({
	chrome = 'section',
	icon,
	title,
	count,
	action,
	actionPlacement = 'above',
	children,
}) => {
	if (chrome === 'bare') {
		const actionRow = action && (
			<div className={`cam-panel__action cam-panel__action--${actionPlacement}`}>
				{action(noop)}
			</div>
		);
		return (
			<>
				{actionPlacement === 'above' && actionRow}
				{children}
				{actionPlacement === 'below' && actionRow}
			</>
		);
	}

	return (
		<CollapsibleSection icon={icon} title={title} count={count} action={action}>
			{children}
		</CollapsibleSection>
	);
};

export default PanelFrame;
